import React from 'react'
import { 
  InputGroup, 
  InputGroupAddon, 
  Input, 
  Button } from 'reactstrap'

export default function Filter({onChg, filter, placeholder,clearFilter}) {
  return (
    <InputGroup>
      <Input
        type='search'
        placeholder={placeholder}
        onChange={onChg}
        value={filter}
        name='filter'
      />
      {filter && <span className="filter-input-clear" onClick={clearFilter}>x</span>}
       <InputGroupAddon addonType='append'>
        <Button><i className='fa fa-search'></i></Button>
      </InputGroupAddon>
    </InputGroup>
  )
}


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManagePane/InfoCard/AssignBlockComponents/Filter.js